import { useEffect, useRef, useState } from 'react';
import SignaturePadLib from 'signature_pad';

export function SignaturePad({ onChange }) {
  const canvasRef = useRef(null);
  const padRef = useRef(null);
  const [hasInk, setHasInk] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    function resize() {
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext('2d').scale(ratio, ratio);
      padRef.current?.clear();
      setHasInk(false);
      onChange?.(null);
    }
    padRef.current = new SignaturePadLib(canvas, {
      backgroundColor: 'rgba(255,255,255,1)',
      penColor: '#0a2c5c',
      minWidth: 0.8,
      maxWidth: 2.2,
    });
    padRef.current.addEventListener('endStroke', () => {
      const empty = padRef.current.isEmpty();
      setHasInk(!empty);
      if (empty) return onChange?.(null);
      onChange?.({
        svg: padRef.current.toSVG(),
        png_b64: padRef.current.toDataURL('image/png').split(',')[1],
      });
    });
    resize();
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, [onChange]);

  function clear() {
    padRef.current?.clear();
    setHasInk(false);
    onChange?.(null);
  }

  return (
    <div>
      <div className="border border-slate-300 rounded-md bg-white">
        <canvas ref={canvasRef} className="w-full h-48 sm:h-56 touch-none rounded-md" />
      </div>
      <div className="flex justify-between items-center mt-2 text-xs text-slate-500">
        <span>{hasInk ? 'Signature captured' : 'Draw your signature above'}</span>
        <button type="button" onClick={clear} className="text-brand-700 hover:underline">Clear</button>
      </div>
    </div>
  );
}
